import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ImageInput, ImagePreview } from "utils/imagePreviewURLConverter";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { CommonSelect, Input, Select, TextArea } from "common/InputForm";
import { v4 as uuid } from "uuid";

import "../product-management.scss";
import {
  addNewProductApi,
  editSelectedProductApi,
  getMasterBrandData,
  getMasterCategoryData,
  getMasterProductType,
  getMasterSubCategoryData,
  getMasterUnitValue,
  selectedProductDetailApi,
} from "services/product-management";
import multiImgUploadToCloudFun from "components/modals/multiImageToCloud";
import JoditEditor from "jodit-react";
import {
  multiSubSubCategoryListApi,
  subCategoryListApi,
} from "services/subCategory";
import DeleteImage from "./DeleteImage";
import { MdOutlineCancel } from "react-icons/md";
import { IoChevronBack } from "react-icons/io5";

const ViewSelectedProduct = () => {
  const blank = () => ({
    _id: uuid(),
    mrp: "",
    unit: "",
    unitValue: "",
    quantity: "",
    stockValue: "",
    highStockValue: "",
    isOutOfStock: false,

    extraStockValue: "",
    outOfStockValue: "",
  });
  const [variants, setVariants] = useState([blank()]);
  const editor = useRef(null);
  const { productId } = useParams();
  const [saltComposition, setSaltComposition] = useState("");
  const id = productId?.split("&")[0];
  const mode = productId?.split("&")[1]?.split("=")[1];

  const isReadMode = mode === "read";
  // console.log('variants', variants)
  const navigate = useNavigate();

  const [error, setError] = useState({});

  // -----cloud img
  //   const [imgInputState, setImageInputState] = useState("");
  const [imgInputState, setImageInputState] = useState([]);

  // -------image preview related state
  const [imgPreviewState, seImgPreviewState] = useState([]);

  // console.log('imgPreviewState', imgPreviewState)
  // ---------------------apply coupon input Checkbox

  const [discountApply, setDiscountApply] = useState(false);
  const [couponNumberState, setCouponNumberState] = useState(0);
  // console.log('couponNumberState', couponNumberState)
  //   -------Right side part

  const [productName, setProductName] = useState("");

  const imgUploadFunction = async (e) => {
    try {
      const data = await multiImgUploadToCloudFun(e?.target?.files);
      // console.log("1st data?.data[0]:-------->", data?.data[0]);
      if (data?.status === 200) {
        //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
        //   setImageInputState(data?.data[0]);
        setImageInputState(data?.data);
        // seImgPreviewState(e?.target?.files[0]);
        seImgPreviewState((prev) => [
          ...prev,
          // e.target.files,
          ...Array.from(e.target.files).map(
            (file) =>
              // URL.createObjectURL(file)
              file,
          ),
        ]);
      }
    } catch (error) {
      console.log("error while uploading and getting data", error);
    }

    // if (!e?.target?.files[0]?.type.includes("image/")) {
    //   setError((stateProp) => ({
    //     ...stateProp,
    //     imgErrorOccur: "Please Choose Image file not others",
    //   }));
    // } else {
    //   try {
    //     const data = await imgUploadToCloudFun(e?.target?.files);
    //     // console.log("1st data?.data[0]:-------->", data?.data[0]);
    //     if (data?.status === 200) {
    //       //   console.log("2nd-------data?.data[0]:-------->", data?.data[0]);
    //       //   setImageInputState(data?.data[0]);
    //       setImageInputState(data?.data);

    //       seImgPreviewState(e?.target?.files[0]);
    //     }
    //   } catch (error) {
    //     console.log("error while uploading and getting data", error);
    //   }
    // }
  };

  // -------------master api data Call

  const [masterBrandState, setMasterBrandState] = useState([]);
  const [masterProductTypeState, setMasterProductTypeState] = useState([]);
  const [masterSubCategoryState, setMasterSubCategoryState] = useState([]);
  const [masterCategoryState, setMasterCategoryState] = useState([]);

  const [subSubCategoryList, setSubSubCategoryList] = useState([]);
  const [subSubCategoryValue, setSubSubCategoryValue] = useState([]);

  // console.log('masterSubCategoryState---->', masterSubCategoryState)
  // -----------description state

  const [descriptionState, setDescriptionState] = useState("");

  // --------------------------data

  const [selectedBrandOptionByAdmin, setSelectedBrandOptionByAdmin] =
    useState("");
  const [
    selectedProductTypeOptionByAdmin,
    setSelectedProductTypeOptionByAdmin,
  ] = useState("");

  // const [selectedCategoryOptionByAdmin, setSelectedCategoryOptionByAdmin] =
  //   useState("");
  const [selectedCategoryOptionByAdmin, setSelectedCategoryOptionByAdmin] =
    useState([]);
  const [multiSelectOptions, setMultiSelectOptions] = useState([]);

  const [masterUnitState, setMasterUnitState] = useState([]);
  // console.log('selectedCategoryOptionByAdmin', selectedCategoryOptionByAdmin)
  //   ----------------checkbox relATED
  const [hotDealApply, setHotDealApply] = useState(false);
  const [notForOnlineSale, setNotForOnlineSale] = useState(false);
  const [awardCoins, setAwardCoins] = useState(false);
  const [billOnlyInStrip, setBillOnlyInStrip] = useState(false);
  const [mrpValue, setMrpValue] = useState(0);
  const [checkData, setCheckData] = useState({
    prescriptionRequired: false,
    eligibleForCoupon: false,
    status: "", // or "ACTIVE"
    isShindhiRecommended: false,
  });

  const [singleProductId, setSingleProductId] = useState("");
  // console.log('checkData', checkData)
  const [deleteImage, setDeleteImage] = useState({ modal: false });
  // ---------handle-image-delete---------
  const handleDeleteImage = (data, index, img) => {
    setDeleteImage({ data, index, img, modal: true });
  };

  const callMasterCategoryApi = async () => {
    const query = { type: "CATEGORY" };
    try {
      const {
        data: { status, code, data },
      } = await getMasterCategoryData(query);

      if (status || code === 200) {
        setMasterCategoryState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterSubCategoryApi = async () => {
    if (selectedCategoryOptionByAdmin.length > 0) {
      const categoryArr = selectedCategoryOptionByAdmin.map(
        (item) => item?.value,
      );
      const query = {
        limit: 1000,
        category: categoryArr,
      };
      try {
        const {
          data: { status, code, data },
          // } = await getMasterSubCategoryData(query);
        } = await subCategoryListApi(query);

        if (status || code === 200) {
          setMasterSubCategoryState(data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const callMasterBrandApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterBrandData();

      if (status || code === 200) {
        setMasterBrandState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callMasterProductType = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterProductType();
      if (status || code === 200) {
        setMasterProductTypeState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const fetchSubSubCategoryList = async () => {
      if (multiSelectOptions.length > 0) {
        // Collect all selected subcategory IDs
        const subCategoryArr = multiSelectOptions.map((item) => item?.value);

        const query = {
          limit: 100,
          subcategories: subCategoryArr,
        };

        try {
          const {
            data: { status, code, data },
          } = await multiSubSubCategoryListApi(query);

          if (status || code === 200) {
            setSubSubCategoryList(data?.data || []);
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetchSubSubCategoryList();
  }, [multiSelectOptions]);
  const callMasterUnitValueApi = async () => {
    try {
      const {
        data: { status, code, data },
      } = await getMasterUnitValue();

      if (status || code === 200) {
        setMasterUnitState(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    callMasterCategoryApi();
    // callMasterSubCategoryApi();
    callMasterBrandApi();
    callMasterProductType();
    callMasterUnitValueApi();
  }, []);
  useEffect(() => {
    callMasterSubCategoryApi();
  }, [selectedCategoryOptionByAdmin]);

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    // if (!imgInputState.length) {
    //   errorObject["imgEmptyErrorMsg"] = "Image is not Set";
    //   status = false;
    // }

    if (!productName.length) {
      errorObject["productName"] = "Product Name is Required";
      status = false;
    }

    // if(!selectedBrandOptionByAdmin.length)
    // {
    //   errorObject["selectedBrandOptionByAdmin"] = "Brand is Required";
    //   status = false;
    // }
    // if (!saltComposition.length) {
    //   errorObject["saltComposition"] = "Salt composition Name is Required";
    //   status = false;
    // }
    if (!selectedProductTypeOptionByAdmin.length) {
      errorObject["selectedProductTypeOptionByAdmin"] =
        "Product Type is Required";
      status = false;
    }

    if (!selectedCategoryOptionByAdmin.length) {
      errorObject["selectedCategoryOptionByAdmin"] = "Category is Required";
      status = false;
    }

    if (!multiSelectOptions.length) {
      errorObject["multiSelectOptions"] = "Sub-Category is Required";
      status = false;
    }

    if (!descriptionState.length) {
      errorObject["descriptionState"] = "Description is Required";
      status = false;
    }

    if (!variants.length) {
      errorObject["variantError"] = "At least one variant is required";
      status = false;
    } else {
      variants.forEach((v, idx) => {
        const missingFields = [];
        if (!v.mrp?.toString().trim()) missingFields.push("MRP");
        if (!v.unit?.toString().trim()) missingFields.push("Unit");
        if (!v.unitValue?.toString().trim()) missingFields.push("Unit Value");
        if (!v.quantity?.toString().trim()) missingFields.push("Quantity");
        if (!v.stockValue?.toString().trim()) missingFields.push("stockValue");
        if (!v.outOfStockValue?.toString().trim())
          missingFields.push("Out Of Stock Value");
        if (missingFields.length) {
          errorObject[`variant_${idx}`] = `Variant ${
            idx + 1
          }: ${missingFields.join(", ")} required`;
          status = false;
        }
      });
    }

    setError(errorObject);

    return status;
  };

  const doSubmit = async () => {
    if (validation()) {
      const { productIds, ...rest } = checkData;
      const dataToSend = {
        ...rest,
        name: productName,
        isDiscountAvailable: discountApply,
        discountPercentage: couponNumberState,
        // category: selectedCategoryOptionByAdmin,
        category: selectedCategoryOptionByAdmin.map((mapPro) => mapPro.value),
        subcategory: multiSelectOptions.map((mapPro) => mapPro.value),
        subsubcategory: subSubCategoryValue.map((mapPro) => mapPro.value),
        brand: selectedBrandOptionByAdmin,
        saltComposition,
        // image: imgInputState,
        description: descriptionState,
        productType: selectedProductTypeOptionByAdmin,
        variant: variants.map((mapProp) => {
          return {
            ...((mapProp._id && { _id: mapProp._id }) || ""),
            mrp: mapProp.mrp,
            isOutOfStock: mapProp.isOutOfStock,
            productType: selectedProductTypeOptionByAdmin,
            unit: mapProp.unit,
            unitValue: mapProp.unitValue,
            quantity: mapProp.quantity,
            stockValue: mapProp.stockValue,

            highStockValue: mapProp.highStockValue,
            extraStockValue: mapProp.extraStockValue,
            outOfStockValue: mapProp.outOfStockValue,
          };
        }),

        isHotDeal: hotDealApply,
        forOnlineSale: notForOnlineSale,
        awardCoin: awardCoins,
        billOnlyInStrip: billOnlyInStrip,
      };

      imgInputState.length === 0
        ? (() => null)()
        : (dataToSend.image = imgInputState);

      try {
        const {
          data: { status, code },
        } = await editSelectedProductApi({ id: productId, data: dataToSend });
        if (status || code === 200) {
          // navigate("/product-management");
          navigate(-1);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const fetchProductDetail = async () => {
    try {
      const {
        data: { status, code, data },
      } = await selectedProductDetailApi(productId);
      // console.log('data', data)
      if (status || code === 200) {
        // console.log('data main fetch', data)
        setSingleProductId(data?._id);
        setProductName(data?.name);
        setSelectedBrandOptionByAdmin(data?.brand);
        setSelectedProductTypeOptionByAdmin(data?.productType);
        // setSelectedCategoryOptionByAdmin(data?.category);
        setSaltComposition(data?.saltComposition);
        setSelectedCategoryOptionByAdmin(
          data?.category?.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setMultiSelectOptions(
          data?.subcategory.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setSubSubCategoryValue(
          data?.subsubcategory?.map((propId) => {
            return { value: propId._id, label: propId.name };
          }),
        );
        setCheckData({
          prescriptionRequired: data?.prescriptionRequired,
          eligibleForCoupon: data?.eligibleForCoupon,
          productIds: data?.productId,
          status: data?.status,
          isShindhiRecommended: data?.isShindhiRecommended,
        });
        // {masterSubCategoryState.map((item) => ({
        //     value: item._id,
        //     label: item.name,
        //   }))}

        setDescriptionState(data?.description);
        setDiscountApply(data?.isDiscountAvailable);
        setCouponNumberState(data?.discountPercentage);
        setHotDealApply(data?.isHotDeal);
        setNotForOnlineSale(data?.forOnlineSale);
        setAwardCoins(data?.awardCoin);
        setBillOnlyInStrip(data?.billOnlyInStrip);
        seImgPreviewState(data?.image || []);

        setVariants(data?.variant);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProductDetail();
  }, []);

  return (
    <div className="add_products">
      {/* <Link to={-1} style={{ color: "#800080" }}>
        Product-Management
      </Link>
      /editNewProduct */}
      <div className="link-header-holder">
        <p>
          <Link to={-1}>
            <IoChevronBack />
            Back
          </Link>
          <span>Product-Management</span>
          &nbsp;
          <span>/ Edit New Product </span>
        </p>
      </div>
      <div className="card">
        {checkData?.productIds && (
          <p>
            Product Id: <b>{checkData?.productIds}</b>
          </p>
        )}
        {/* ------------------------------left side part starts */}
        <div className="form_field_wrap">
          <div className="form_field">
            <Input
              label="Product Name"
              value={productName}
              onChange={(e) => {
                setProductName(e.target.value);
              }}
            />

            {error["productName"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["productName"]}
                </p>
              </div>
            )}
          </div>

          {masterBrandState.length > 0 && (
            <div className="form_field">
              <Select
                label="Select Brand"
                value={selectedBrandOptionByAdmin}
                onChange={(e) => {
                  setSelectedBrandOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Brand</option>
                {masterBrandState.map((brandMapProp, ind) => (
                  <option value={brandMapProp._id} key={ind}>
                    {brandMapProp.name}
                  </option>
                ))}
              </Select>
            </div>
          )}
          {/* --------------------master product type select */}

          {masterProductTypeState.length > 0 && (
            <div className="form_field">
              <Select
                label="Product Type"
                value={selectedProductTypeOptionByAdmin}
                onChange={(e) => {
                  setSelectedProductTypeOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Product Type</option>
                {masterProductTypeState?.map((productTypeMapProp, ind) => (
                  <option value={productTypeMapProp._id} key={ind + 1}>
                    {productTypeMapProp.name}
                  </option>
                ))}
              </Select>

              {error["selectedProductTypeOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedProductTypeOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* -------------- masterCategoryState */}
          {/* {masterCategoryState.length > 0 && (
            <div className="form_field">
              <Select
                label="Category Name"
                value={selectedCategoryOptionByAdmin}
                onChange={(e) => {
                  setSelectedCategoryOptionByAdmin(e.target.value);
                }}
              >
                <option value="">Select Category</option>
                {masterCategoryState.map((categoryMapProp, ind) => (
                  <option value={categoryMapProp._id} key={ind + 2}>
                    {categoryMapProp.name}
                  </option>
                ))}
              </Select>

              {error["selectedCategoryOptionByAdmin"] && (
                <div>
                  <p style={{ color: "red", marginTop: 4 }}>
                    {error["selectedCategoryOptionByAdmin"]}
                  </p>
                </div>
              )}
            </div>
          )} */}
          <div className="form_field">
            <CommonSelect
              value={selectedCategoryOptionByAdmin || []}
              label="Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSelectedCategoryOptionByAdmin(commonSelectData);
                setMultiSelectOptions([]);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterCategoryState.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["selectedCategoryOptionByAdmin"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["selectedCategoryOptionByAdmin"]}
                </p>
              </div>
            )}
          </div>
          {/* ---------------masterSubCategoryState  */}

          {/* {masterSubCategoryState.length > 0 && ( */}
          <div className="form_field">
            <CommonSelect
              value={multiSelectOptions || []}
              label="Sub-Category Name"
              name="SubCategoryName"
              isMulti={true}
              onChange={(commonSelectData) => {
                setMultiSelectOptions(commonSelectData);
                setSubSubCategoryValue([]);
              }}
              // options={[
              //   { value: "apple", label: "Apple" },
              //   { value: "banana", label: "Banana" },
              //   { value: "mango", label: "Mango" },
              //   { value: "grape", label: "Grape" },
              // ]}
              options={masterSubCategoryState?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />

            {error["multiSelectOptions"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["multiSelectOptions"]}
                </p>
              </div>
            )}
          </div>
          <div className="form_field">
            <CommonSelect
              value={subSubCategoryValue || []}
              label="Filter Category Name"
              name="subsubcategory"
              isMulti={true}
              onChange={(commonSelectData) => {
                setSubSubCategoryValue(commonSelectData);
              }}
              options={(subSubCategoryList || [])?.map((item) => ({
                value: item._id,
                label: item.name,
              }))}
              isSearchable={true}
            />
          </div>
          <div className="form_field">
            <TextArea
              label="salt Composition"
              placeholder="salt Composition"
              name="saltComposition"
              value={saltComposition}
              onChange={(e) => {
                setSaltComposition(e.target.value);
              }}
              
            />

            {/* {error["saltComposition"] && (
              <div>
                <p className="error">{error["saltComposition"]}</p>
              </div>
            )} */}
          </div>
          {/* )} */}

          {/* --------------------Description ------------- */}

          <div className="form_field w-100">
            {/* <TextArea
              label="Description"
              value={descriptionState}
              onChange={(e) => {
                setDescriptionState(e.target.value);
              }}
              maxLength={200}
            /> */}
            <label htmlFor="">Description</label>
            <JoditEditor
              ref={editor}
              value={descriptionState}
              tabIndex={1}
              onBlur={(newContent) => setDescriptionState(newContent)}
              config={{
                readonly: false,
                height: 200,
                placeholder: "Edit content here...",
              }}
            />

            {error["descriptionState"] && (
              <div>
                <p style={{ color: "red", marginTop: 4 }}>
                  {error["descriptionState"]}
                </p>
              </div>
            )}
          </div>

          <div className="form_field_wrap">
            <DynamicInputField
              variants={variants}
              setVariants={setVariants}
              blank={blank}
              masterUnitState={masterUnitState}
              error={error}
            />
          </div>

          {/* -----------stock value */}
        </div>

        {/* ---------------------------------right side */}
        <div className="form_field_wrap">
          <div className="form_field">
            <label className="label">Change Image</label>
            <input
              onChange={imgUploadFunction}
              type="file"
              accept="image/*"
              className="form-control"
              multiple
            />

            {error["imgEmptyErrorMsg"] && (
              <span className="error">{error["imgEmptyErrorMsg"]}</span>
            )}
            {error["imgErrorOccur"] && (
              <p className="error">{error["imgErrorOccur"]}</p>
            )}

            {/* ------image preview Container div */}
            <div className="image_preview multi_preview">
              {imgPreviewState.length > 0 &&
                imgPreviewState.map((imag, ind) => {
                  return (
                    // imag.file ? <ImagePreview file={imag?.file} key={ind} /> :
                    <div key={ind} className="item">
                      <MdOutlineCancel
                        onClick={() =>
                          handleDeleteImage(singleProductId, ind, imag)
                        }
                      />
                      <ImagePreview file={imag} key={ind} />
                    </div>
                  );
                })}
            </div>
            {/* ----end of img preview component */}
          </div>

          {/* ------------set coupon and checkbox  */}
          <div className="form_field">
            <label htmlFor="couponIdApply" className="label">
              <input
                id="couponIdApply"
                type="checkbox"
                onChange={(e) => {
                  setDiscountApply(e.target.checked);
                  if (!e.target.checked) {
                    setCouponNumberState(0); // Reset the state itself
                  }
                }}
                value={discountApply}
                checked={discountApply}
              />{" "}
              Apply Discount(%)
            </label>

            <Input
              type="text"
              name="couponNumber"
              value={couponNumberState}
              // onChange={(e) => {
              //   setCouponNumberState(e.target.value);
              // }}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers using regex
                if (/^\d*$/.test(value)) {
                  setCouponNumberState(value);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              disabled={!discountApply}
              maxLength={2}
            />

            {/* ------------set coupon and checkbox  */}
            <div className="select_list">
              <label htmlFor="markInHotDealIdApply">
                <input
                  id="markInHotDealIdApply"
                  type="checkbox"
                  onChange={(e) => {
                    setHotDealApply(e.target.checked);
                  }}
                  value={hotDealApply}
                  checked={hotDealApply}
                />{" "}
                Mark In Hot Deals
              </label>

              <label htmlFor="notForSaleId">
                <input
                  id="notForSaleId"
                  type="checkbox"
                  value={notForOnlineSale}
                  onChange={(e) => {
                    setNotForOnlineSale(e.target.checked);
                  }}
                  checked={notForOnlineSale}
                />{" "}
                Not For Online Sales
              </label>

              <label htmlFor="forAwardCoinId">
                <input
                  id="forAwardCoinId"
                  type="checkbox"
                  value={awardCoins}
                  onChange={(e) => {
                    setAwardCoins(e.target.checked);
                  }}
                  checked={awardCoins}
                />{" "}
                Award Coins
              </label>

              <label htmlFor="prescriptionRequired">
                <input
                  id="prescriptionRequired"
                  type="checkbox"
                  checked={checkData.prescriptionRequired}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      prescriptionRequired: e.target.checked,
                    })
                  }
                />{" "}
                {"Prescription Required/OTC (Over the Counter)"}
              </label>

              <label htmlFor="eligibleForCoupon">
                <input
                  id="eligibleForCoupon"
                  type="checkbox"
                  checked={checkData.eligibleForCoupon}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      eligibleForCoupon: e.target.checked,
                    })
                  }
                />{" "}
                Eligible for Coupon
              </label>

              <label htmlFor="InvisibleOption">
                <input
                  id="InvisibleOption"
                  type="checkbox"
                  checked={checkData.status === "INACTIVE"} // convert string to boolean
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      status: e.target.checked ? "INACTIVE" : "ACTIVE", // toggle string value
                      // status: e.target.checked ? "ACTIVE" : "INACTIVE", // toggle string value
                    })
                  }
                />{" "}
                Invisible Option
              </label>

              <label htmlFor="isShindhiRecommended">
                <input
                  id="isShindhiRecommended"
                  type="checkbox"
                  checked={checkData.isShindhiRecommended}
                  onChange={(e) =>
                    setCheckData({
                      ...checkData,
                      isShindhiRecommended: e.target.checked,
                    })
                  }
                />{" "}
                sindhi Recommended
              </label>
              <label htmlFor="billOnlyInStrip">
                <input
                  id="billOnlyInStrip"
                  type="checkbox"
                  value={billOnlyInStrip}
                  onChange={(e) => {
                    setBillOnlyInStrip(e.target.checked);
                  }}
                  checked={billOnlyInStrip}
                />{" "}
                Bill Only In Strip
              </label>
            </div>
          </div>

          {/* ----------------mark in hot deal */}
        </div>

        {/* --------add product  */}
        {/* <div className="button_wrap">
          <button className="button" type="button" onClick={doSubmit}>
            Update Product
          </button>
        </div> */}
      </div>
      <DeleteImage
        show={deleteImage?.modal}
        close={() => setDeleteImage({ modal: false })}
        listing={fetchProductDetail}
        data={deleteImage}
        setState={seImgPreviewState}
      />
    </div>
  );
};

export default ViewSelectedProduct;

const DynamicInputField = ({
  variants,
  setVariants,
  blank,
  masterUnitState,
  error,
}) => {
  const update = (id, key, val) =>
    setVariants((cur) =>
      cur.map((v) => (v._id === id ? { ...v, [key]: val } : v)),
    );

  const add = () => setVariants((cur) => [...cur, blank()]);
  const remove = (id) => {
    setVariants((cur) =>
      cur.length > 1 ? cur.filter((v) => v._id !== id) : cur,
    );
  };

  return (
    <div>
      {variants.map((v, i) => (
        <div className="append_list" key={v._id}>
          {error[`variant_${i}`] && (
            <p style={{ color: "red", marginBottom: 4 }}>
              {error[`variant_${i}`]}
            </p>
          )}

          <div className="form_field">
            <Input
              type="text"
              label="MRP"
              placeholder="MRP"
              value={v.mrp}
              // onChange={(e) => update(v._id, "mrp", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "mrp", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>
          <div className="form_field">
            <Select
              value={v.unit}
              label="Select Unit"
              onChange={(e) => update(v._id, "unit", e.target.value)}
            >
              <option value="">Select Unit</option>
              {masterUnitState.map((unit, idx) => (
                <option key={idx} value={unit.name}>
                  {unit.name}
                </option>
              ))}
            </Select>
          </div>
          <div className="form_field">
            <Input
              type="text"
              label="Unit Size"
              placeholder="Unit Value"
              value={v.unitValue || ""}
              // onChange={(e) => update(v._id, "unitValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "unitValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>
          <div className="form_field">
            <Input
              type="text"
              label="Quantity"
              placeholder="Quantity"
              value={v.quantity}
              // onChange={(e) => update(v._id, "quantity", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "quantity", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>
          <div className="form_field">
            <Input
              type="text"
              label="Stock Quantity"
              placeholder="Stock Value"
              value={v.stockValue || ""}
              disabled
              // onChange={(e) => update(v._id, "stockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "stockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="extra Stock Value"
              placeholder="Extra Stock Value"
              value={v.extraStockValue || ""}
              // onChange={(e) => update(v._id, "extraStockValue", e.target.value)}
              inputMode="numeric"
              name="extraStockValue"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "extraStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="Minimum Stock Quantity"
              placeholder="Minimum Stock Quantity"
              value={v.outOfStockValue || ""}
              // onChange={(e) => update(v._id, "outOfStockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "outOfStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <Input
              type="text"
              label="high Stock Value"
              placeholder="high Stock Value"
              value={v.highStockValue || ""}
              // onChange={(e) => update(v._id, "outOfStockValue", e.target.value)}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={9}
              onChange={(e) => {
                let input = e.target.value;
                input = input.replace(/\s+/g, "");
                if (/^\d*\.?\d{0,2}$/.test(input)) {
                  update(v._id, "highStockValue", input);
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key))
                  e.preventDefault();
              }}
            />
          </div>

          <div className="form_field">
            <label className="label dummy">Dummy</label>
            <label>
              <input
                type="checkbox"
                checked={v.isOutOfStock}
                onChange={(e) =>
                  update(v._id, "isOutOfStock", e.target.checked)
                }
                className="me-1"
              />
              Mark Out of Stock
            </label>
          </div>
          {variants.length > 1 && (
            <div className="form_field">
              <button
                style={{ marginTop: "1rem" }}
                type="button"
                className="button"
                onClick={() => remove(v._id)}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      ))}

      {/* <div className="button_wrap button_right">
        <button type="button" className="button" onClick={add}>
          + Add another variant
        </button>
      </div> */}
    </div>
  );
};
